export default __webpack_public_path__ + "static/media/PrescriptionsSelectedIcon.351a8eed.svg";